export const notificationRoutes = [
  {
    component: () =>
      import('@/domains/notifications/pages/EmailActionReviewPage.vue'),
    meta: { layout: false, requiresAuth: false },
    name: 'email-action-review',
    path: '/email-actions/review',
  },
]
